import { cn } from '../../lib/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  ariaLabel?: string;
}

const sizes = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-12 h-12 border-4',
};

export function Spinner({ size = 'md', className, ariaLabel = 'Загрузка' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={cn(
        'inline-block rounded-full border-tg-hint/40 border-t-brand animate-spin',
        sizes[size],
        className,
      )}
    />
  );
}
